export default __webpack_public_path__ + "static/media/Contact page image 4.fb5d610a.png";